import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from './Global';

@Injectable({
  providedIn: 'root'
})

export class UserService {
   private _http = inject(HttpClient)
   private url = Global.url_user
   private _headers = new HttpHeaders().set('Content-Type', 'application/json');

  public userData = signal(null)
  public userPhoto = signal<string | null>(null)
  public sharingIdentity = signal({})
  public sharingEntity = signal({})
  public sharingEntities = signal<[]>([])
  public sharingLanguage = signal({})
  public sharingRole = signal({})
  public sharingMenu = signal<[]>([])
  public sharingMenuPath = signal({})

  processUserData(userData?: any) {
    if(userData) this.userData.set(userData)
  }

  resetState() {
    this.userData.set(null)
    this.userPhoto.set(null)
    this.sharingIdentity.set({})
    this.sharingEntity.set({})
    this.sharingEntities.set([])
    this.sharingLanguage.set({})
    this.sharingRole.set({})
    this.sharingMenu.set([])
    this.sharingMenuPath.set({})
  }

  processUserPhoto(arrayBuffer?: ArrayBuffer) {
    if (!arrayBuffer) return
    const url = this.arrayBufferToUrl(arrayBuffer);
    this.userPhoto.set(url)
  }

  private arrayBufferToUrl(arrayBuffer: ArrayBuffer): string {
    const array = new Uint8Array(arrayBuffer);
    const blob = new Blob([array], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  }

  getUsers(search?: string): Observable<any> {
    const suffix = search ? `users/${search}` : 'users';
    return this._http.get(this.url + suffix, { headers: this._headers });
  }

  updateUser(user: any) {
    return this._http.put(this.url + `users`, user, { headers: this._headers });
  }

  reorderUsers(users: { id: string; index: number }[]) {
    return this._http.put(this.url + `users/reorder`, users, { headers: this._headers });
  }

  getRoles() {
   return this._http.get(`${this.url}roles`, { headers: this._headers });
  }

  getMenus() {
    return this._http.get(this.url + `menus`, { headers: this._headers });
  }

  getMenuByRole(roleId: string) {
    return this._http.get(this.url + `menus/${roleId}`, { headers: this._headers });
  }

  updateMenu(menu: any) {
    return this._http.put(this.url + `menus`, menu, { headers: this._headers });
  }

  toggleMenuRole(roleId: string, menuId: string, enabled: boolean) {
    return this._http.put(this.url + `menus/toggle-role`, { roleId, menuId, enabled }, { headers: this._headers });
  }

  toggleMenuRoleBulk(items: { roleId: string; menuId: string; enabled: boolean }[]) {
    return this._http.put(this.url + `menus/toggle-role-bulk`, items, { headers: this._headers });
  }

  reorderMenus(menus: any[]) {
    return this._http.put(this.url + `menus/reorder`, menus, { headers: this._headers });
  }

  deleteMenu(menuId: string) {
    return this._http.delete(this.url + `menus/${encodeURIComponent(menuId)}`, { headers: this._headers });
  }

  updateRole(role: any) {
    return this._http.put(this.url + `roles`, role, { headers: this._headers });
  }

  reorderRoles(roles: { id: string; index: number }[]) {
    return this._http.put(this.url + `roles/reorder`, roles, { headers: this._headers });
  }

  cloneRoleMenus(fromRoleId: string, toRoleId: string) {
    return this._http.post(this.url + `menus/clone-role`, { fromRoleId, toRoleId }, { headers: this._headers });
  }

  accessCheck(userId: string) {
    return this._http.get(this.url + `users/${encodeURIComponent(userId)}/access-check`, { headers: this._headers });
  }

}
